// Faixas disponíveis para a justificativa no Portal de Justificativas.
// `cod` é o valor persistido em request.faixa (raiz da Request.js);
// `descricao` é o rótulo exibido no dropdown.
const FaixaJustificativa = [
    { cod: "99", descricao: "99" },
    { cod: "1", descricao: "1" },
    { cod: "2", descricao: "2" },
    { cod: "3", descricao: "3" },
    { cod: "4", descricao: "4" },
];

export default FaixaJustificativa;
